export default __webpack_public_path__ + "static/media/work-seven.9b84333b.PNG";